export default __webpack_public_path__ + "static/media/My_Lists_Icon.8879aabd.svg";